import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { stringify } from 'querystring';
import { InteractionsService } from 'src/app/services/interactions.service';

@Component({
  selector: 'app-interaction',
  templateUrl: './interaction.component.html',
  styleUrls: ['./interaction.component.scss']
})
export class InteractionComponent implements OnInit {

  @Input('interaction') interaction;

  interactionOpened: string[];

  constructor(
    private router: Router,
    private interactionsService: InteractionsService
  ) { }

  ngOnInit(): void {
  }

  goToInteraction() {
    if (this.interaction.comingSoon) {
      console.log('Aspetta che fra poco arriva');
      /*this.router.navigate(['/comingsoon/' + id]);*/
    } else {
      if (!this.interaction.opened) {
        this.interactionOpened = localStorage.getItem('interactionIds') ? JSON.parse(localStorage.getItem('interactionIds')) : [];
        this.interactionOpened.push(this.interaction.id);
        localStorage.setItem('interactionIds', JSON.stringify(this.interactionOpened));
        this.interaction.opened = 1;
        this.interactionsService.updateInteraction(this.interaction);
      }
      if (this.interaction.type !== 'custom') {
        this.router.navigate(['/interaction/', this.interaction.type, this.interaction.url]);
      } else {
        this.router.navigate(['/interaction-custom/', this.interaction.type, this.interaction.url]);
      }
    }
  }


}
